<template>
  <section
    id="logos"
    class="logo-section"
  >
    <div
      class="object"
      :class="objectAnimated"
    ></div>
    <div
      class="cube"
      :class="cubeAnimated"
    ></div>
    <div
      class="sphere"
      :class="sphereAnimated"
    ></div>
    <h1>
      Top companies want to
      <br />
      work with you
    </h1>
    <div
      class="marquee"
      :class="{ container: isMobile }"
    >
      <div class="track">
        <div
          v-for="(logo, index) in logos?.firstSectionLogos || []"
          :key="`logo1-${index}`"
          class="logo"
        >
          <picture>
            <source
              :srcSet="logo.image_url"
              type="image/png"
            />
            <img
              :src="logo.image_url"
              :alt="logo.company"
              loading="lazy"
            />
          </picture>
        </div>

        <div
          v-for="(logo, index) in logos?.secondSectionLogos || []"
          :key="`logo2-${index}`"
          class="logo desktop-only"
        >
          <picture>
            <source
              :srcSet="logo.image_url"
              type="image/png"
            />
            <img
              :src="logo.image_url"
              :alt="logo.company"
              loading="lazy"
            />
          </picture>
        </div>

        <div
          v-for="(logo, index) in logos?.firstSectionLogos || []"
          :key="`logo3-${index}`"
          class="logo desktop-only"
        >
          <picture>
            <source
              :srcSet="logo.image_url"
              type="image/png"
            />
            <img
              :src="logo.image_url"
              :alt="logo.company"
              loading="lazy"
            />
          </picture>
        </div>

        <div
          v-for="(logo, index) in logos?.secondSectionLogos || []"
          :key="`logo4-${index}`"
          class="logo desktop-only"
        >
          <picture>
            <source
              :srcSet="logo.image_url"
              type="image/png"
            />
            <img
              :src="logo.image_url"
              :alt="logo.company"
              loading="lazy"
            />
          </picture>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import isMobile from '~/mixins/responsive';

export default {
  mixins: [isMobile],

  props: {
    logos: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      cubeAnimated: 'cube-not-animated',
      sphereAnimated: 'sphere-not-animated',
      objectAnimated: 'object-not-animated',
      observer: null,
    };
  },

  mounted() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.8,
    };

    const callback = (entries) => {
      if (entries[0].isIntersecting) {
        this.cubeAnimated = 'cube-animated';
        this.sphereAnimated = 'sphere-animated';
        this.objectAnimated = 'object-animated';
      } else {
        this.cubeAnimated = 'cube-not-animated';
        this.sphereAnimated = 'sphere-not-animated';
        this.objectAnimated = 'object-not-animated';
      }
    };

    this.observer = new IntersectionObserver(callback.bind(this), options);
    const section = document.querySelector('#logos');
    this.observer.observe(section);
  },
};
</script>

<style lang="scss" scoped>
@import './LogoSection.scss';
</style>
